// Redesign line-icon set, 1:1 with the approved mockup's SVG symbols.
// All icons draw with currentColor so they inherit text color.

interface IconProps {
	size?: number;
	className?: string;
}

const svgProps = (size: number, className?: string) => ({
	width: size,
	height: size,
	viewBox: '0 0 24 24',
	fill: 'none' as const,
	xmlns: 'http://www.w3.org/2000/svg',
	'aria-hidden': true as const,
	className,
});

export const IcBasket = ({ size = 19, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M6 8L9 3M18 8l-3-5M3.5 8h17l-1.6 10.2a2 2 0 0 1-2 1.8H7.1a2 2 0 0 1-2-1.8L3.5 8Z'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcUserRound = ({ size = 19, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='8.5' r='3.5' stroke='currentColor' strokeWidth='1.7' />
		<path
			d='M5 20c1.4-3 4-4.5 7-4.5s5.6 1.5 7 4.5'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcGear = ({ size = 16, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='12' r='3.1' stroke='currentColor' strokeWidth='1.7' />
		<path
			d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.08a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.08a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.08a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcArrowRight = ({ size = 18, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M4 12h16m-6-6 6 6-6 6'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcPlayOutline = ({ size = 19, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M8 5.5v13l11-6.5-11-6.5Z'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcOpenPage = ({ size = 17, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M18.5 13.5v5a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h5'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M14.5 3.5h6v6'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M10.5 13.5 20 4'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcDoc = ({ size = 19, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M7 3h7l4 4v14H7V3Zm7 0v4h4M10 12h5m-5 4h5'
			stroke='currentColor'
			strokeWidth='1.6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcCheck = ({ size = 16, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M5 13l4.5 4.5L19 7'
			stroke='currentColor'
			strokeWidth='2.6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcCopy = ({ size = 21, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='9'
			y='9'
			width='11'
			height='11'
			rx='2.5'
			stroke='currentColor'
			strokeWidth='1.6'
		/>
		<path
			d='M5 15V6a2 2 0 0 1 2-2h9'
			stroke='currentColor'
			strokeWidth='1.6'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcClose = ({ size = 15, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M6 6l12 12M18 6 6 18'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcPower = ({ size = 16, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M12 3v9M18.4 6.6a9 9 0 1 1-12.8 0'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcTv = ({ size = 18, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3'
			y='5'
			width='18'
			height='12'
			rx='2'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<path
			d='M9 20h6'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcPlusRound = ({ size = 24, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='12' r='9.5' stroke='currentColor' strokeWidth='1.7' />
		<path
			d='M12 8v8M8 12h8'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcSun = ({ size = 17, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='12' r='4.2' stroke='currentColor' strokeWidth='1.7' />
		<path
			d='M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M18.5 5.5l-1.7 1.7M7.2 16.8l-1.7 1.7'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcMoon = ({ size = 16, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcChevronDown = ({ size = 14, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='m6 9.5 6 6 6-6'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcMenuLines = ({ size = 22, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M4 7h16M4 12h16M4 17h16'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcCard = ({ size = 22, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='2.5'
			y='5'
			width='19'
			height='14'
			rx='2.5'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<path d='M2.5 9.5h19' stroke='currentColor' strokeWidth='1.7' />
		<path
			d='M6 14.5h4'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcPlus = ({ size = 16, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M12 5v14M5 12h14'
			stroke='currentColor'
			strokeWidth='2.2'
			strokeLinecap='round'
		/>
	</svg>
);

/* Brand »kjupitnik«: the wordmark's Q alone (paths lifted 1:1 from
   LogoWordmark), for the mobile home tab. Height-driven sizing keeps the
   glyph's own aspect ratio. */
export const IcKjupitnik = ({ size = 22, className }: IconProps) => (
	<svg
		width={(size * 104) / 153}
		height={size}
		viewBox='0 0 104 153'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden
		className={className}
	>
		<path
			d='M95.8359 16.8563C101.716 23.2354 103.512 32.3112 101.224 44.0838L86.2997 120.863C83.3249 136.167 66.9087 119.733 67.8315 114.986L68.7542 110.239L68.7581 110.219L81.8304 42.932C83.0835 36.4852 83.226 31.6404 82.2578 28.3979C81.3168 25.0152 79.1214 22.4795 75.6714 20.7908C72.2487 18.9619 66.8267 17.3262 59.4054 15.8836C50.7238 14.1961 44.3973 13.4754 40.426 13.7216C36.5946 13.995 33.7628 15.4807 31.9305 18.1789C30.2382 20.9043 28.7382 25.6306 27.4306 32.3578L20.1977 69.5675C19.0808 75.3136 19.0901 79.7515 20.2255 82.8811C21.361 86.0107 23.7101 88.5036 27.2728 90.3596C29.1042 91.2155 31.3637 92.0319 34.0512 92.8087L38.0567 93.5962C41.3583 94.238 47.6424 109.293 36.9986 107.224L32.1643 106.284C31.6357 106.188 30.4614 105.931 30.0206 105.83C26.9807 105.132 24.3957 104.451 22.2654 103.785C18.5665 102.63 15.0192 101.068 11.6238 99.0988C8.11551 96.9624 5.48637 94.4152 3.73632 91.457C1.98628 88.4988 0.833392 84.7113 0.277651 80.0945C-0.305331 75.6178 0.0297499 70.156 1.2829 63.7092L8.59746 26.079C10.8858 14.3064 16.161 6.60512 24.423 2.97509C32.8523 -0.767888 45.6085 -0.979068 62.6916 2.34155C78.9345 5.49885 89.9826 10.3371 95.8359 16.8563Z'
			fill='currentColor'
		/>
		<path
			d='M74.6355 152.206C77.629 152.788 80.5279 150.831 81.1103 147.835L82.0331 143.088C82.9558 138.341 66.5396 121.907 63.5648 137.211L62.2137 144.162C61.6313 147.158 63.5859 150.059 66.5795 150.64L74.6355 152.206Z'
			fill='currentColor'
		/>
	</svg>
);

/* Google's four-color G — brand mark, fixed colors by design (the one
   exception to the currentColor rule). */
export const IcGoogleG = ({ size = 18, className }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 18 18'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden
		className={className}
	>
		<path
			fill='#4285F4'
			d='M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62z'
		/>
		<path
			fill='#34A853'
			d='M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z'
		/>
		<path
			fill='#FBBC05'
			d='M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z'
		/>
		<path
			fill='#EA4335'
			d='M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z'
		/>
	</svg>
);

export const IcCards = ({ size = 22, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3'
			y='7'
			width='14'
			height='12'
			rx='2'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<path
			d='M7 4h13a1 1 0 0 1 1 1v11'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
		<path d='M8.5 11v4.5l4-2.25-4-2.25Z' fill='currentColor' />
	</svg>
);

export const IcGift = ({ size = 20, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='4'
			y='8'
			width='16'
			height='4'
			rx='1'
			stroke='currentColor'
			strokeWidth='1.6'
		/>
		<path
			d='M5.5 12v8h13v-8M12 8v12M12 8s-1.2-4-4-4c-1.5 0-2.5 1-2.5 2S6.5 8 8 8h4Zm0 0s1.2-4 4-4c1.5 0 2.5 1 2.5 2S17.5 8 16 8h-4Z'
			stroke='currentColor'
			strokeWidth='1.6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcMail = ({ size = 19, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3'
			y='5.5'
			width='18'
			height='13.5'
			rx='2.5'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<path
			d='M4.5 8l7.5 5.4L19.5 8'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcBell = ({ size = 20, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M18 8.4a6 6 0 0 0-12 0c0 6.1-2.5 7.9-2.5 7.9h17S18 14.5 18 8.4Z'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M13.7 19.8a2 2 0 0 1-3.4 0'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcInfo = ({ size = 20, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.6' />
		<path
			d='M12 11v5.4'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
		<circle cx='12' cy='7.6' r='1.15' fill='currentColor' />
	</svg>
);

export const IcAlertTriangle = ({ size = 20, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M10.34 4.15 3.28 16.6a1.9 1.9 0 0 0 1.65 2.84h14.14a1.9 1.9 0 0 0 1.65-2.84L13.66 4.15a1.9 1.9 0 0 0-3.32 0Z'
			stroke='currentColor'
			strokeWidth='1.6'
			strokeLinejoin='round'
		/>
		<path
			d='M12 9.1v4.3'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
		/>
		<circle cx='12' cy='16.3' r='1.1' fill='currentColor' />
	</svg>
);

export const IcAlertRound = ({ size = 20, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.6' />
		<path
			d='m9.3 9.3 5.4 5.4m0-5.4-5.4 5.4'
			stroke='currentColor'
			strokeWidth='1.7'
			strokeLinecap='round'
		/>
	</svg>
);

export const IcFacebook = ({ size = 18, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<path
			d='M14.5 8.5V7c0-.8.7-1.5 1.5-1.5h1.5V2.8h-2.6c-2.2 0-3.6 1.7-3.6 3.9v1.8H9v2.9h2.3v9.8h3.2v-9.8h2.4l.4-2.9h-2.8Z'
			stroke='currentColor'
			strokeWidth='1.4'
			strokeLinejoin='round'
		/>
	</svg>
);

export const IcInstagram = ({ size = 18, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3.5'
			y='3.5'
			width='17'
			height='17'
			rx='4.5'
			stroke='currentColor'
			strokeWidth='1.6'
		/>
		<circle cx='12' cy='12' r='3.8' stroke='currentColor' strokeWidth='1.6' />
		<circle cx='16.9' cy='7.1' r='1.05' fill='currentColor' />
	</svg>
);

export const IcGrid = ({ size = 17, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3.5'
			y='3.5'
			width='7'
			height='7'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<rect
			x='13.5'
			y='3.5'
			width='7'
			height='7'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<rect
			x='3.5'
			y='13.5'
			width='7'
			height='7'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<rect
			x='13.5'
			y='13.5'
			width='7'
			height='7'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
	</svg>
);

export const IcRows = ({ size = 17, className }: IconProps) => (
	<svg {...svgProps(size, className)}>
		<rect
			x='3.5'
			y='4'
			width='17'
			height='6.5'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
		<rect
			x='3.5'
			y='13.5'
			width='17'
			height='6.5'
			rx='1.8'
			stroke='currentColor'
			strokeWidth='1.7'
		/>
	</svg>
);
